import React from "react";
import {withTranslation, WithTranslation} from "react-i18next";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {BulkProducts, GetBulkProductSearchDataResponse, ProductInfo,} from "src/model/ProductMatch";
import MetricsUtil from "src/utils/MetricsUtil";
import ApplicationState from "src/model/ApplicationState";
import {KatButton, KatSpinner} from "@amzn/katal-react";
import RequestStatus from "src/model/RequestStatus";
import {CSVLink} from "react-csv";
import {transReport} from "src/utils/ReportUtil";
import {GetReportResponse} from "src/model/ProgramFees";
import {setBulkProductsQueryClear, setBulkProductsQueryStart} from "src/actions/BulkReportQueryAction";
import ErrorStatusComponent from "src/components/common/ErrorStatusComponent";
import {delAllProducts} from "src/actions/BulkProductAction";
import moment from 'moment';

interface StateProps {
    bulkProductSearchRes: GetBulkProductSearchDataResponse,
    bulkReportRes: GetReportResponse,
    bulkProductsRes: BulkProducts,
}

interface OwnProps {
    readonly metricsUtil?: MetricsUtil,
    readonly currentCountryCode: string,
    readonly handleStepChange: Function
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    bulkProductSearchRes: state.bulkProductSearchRes,
    bulkReportRes: state.bulkReportRes,
    bulkProductsRes: state.bulkProductsRes,
});

interface DispatchProps {
    readonly dispatchBulkProductsQueryStart: (countryCode: string, products: Array<ProductInfo>) => void,
    readonly dispatchDelAllProducts: () => void,
    readonly dispatchBulkProductsQueryClear: () => void
}

const mapDispatchToProps = (dispatch: Dispatch) => (
    bindActionCreators({
        dispatchBulkProductsQueryStart: setBulkProductsQueryStart,
        dispatchDelAllProducts: delAllProducts,
        dispatchBulkProductsQueryClear: setBulkProductsQueryClear
    }, dispatch)
);

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = StateProps & OwnProps & DispatchProps & WithTranslation;

interface State {
}

export class DownloadReportComponent extends React.Component<Props, State> {

    protected readonly metricsUtil: MetricsUtil;

    constructor(props: Props) {
        super(props);
        this.state = {};
        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }
    }

    publishCounter(method: string, counter: string) {
        if (this.metricsUtil) {
            this.metricsUtil.publishCounter(method, counter);
        }
    }

    render() {
        const {t} = this.props;
        return (
            <>
                <div>
                    {this.props.bulkReportRes.requestStatus == RequestStatus.LOADING &&
                    <div>
                        <KatSpinner/>
                        <p>{t("SC_FBA_Calc_bulk_processing_info", {X: 1})}</p>
                        {/*todo: display this info string after past reports launch*/}
                        {/*<p>{t("SC_FBA_Calc_bulk_submit_info")}</p>*/}
                    </div>
                    }
                    {(this.props.bulkReportRes.requestStatus == RequestStatus.NOT_LOADED ||
                        this.props.bulkReportRes.requestStatus == RequestStatus.ERROR) &&
                    <KatButton label={t("SC_FBA_Calc_bulk_generate_report")}
                               disabled={this.props.bulkProductsRes.products.length == 0}
                               onClick={() => {
                        this.props.dispatchBulkProductsQueryStart(this.props.currentCountryCode, this.props.bulkProductsRes.products);
                    }}/>}
                    {this.props.bulkReportRes.requestStatus == RequestStatus.ERROR &&
                    <ErrorStatusComponent description={t('SC_FBA_Calc_error_productMatchFailed')}/>}
                    {this.props.bulkReportRes.requestStatus == RequestStatus.SUCCESS &&
                    <CSVLink data={transReport(this.props.bulkReportRes.report?.batchFeeEstimationCsvReport, t) ?? []}
                             filename={"RevCal_" + moment(new Date()).format("YYYY-MM-DD_HH-mm-ss")}>
                        <KatButton label={t("SC_FBA_Calc_btn_download")} variant="primary"
                                   disabled={this.props.bulkReportRes.requestStatus != RequestStatus.SUCCESS}
                                   onClick={() => {
                                       this.publishCounter("downloadReport", "click");
                                   }}
                        />
                    </CSVLink>
                    }
                    <KatButton label={t("SC_FBA_Calc_bulk_start_new_bulk")} variant="secondary"
                               disabled={this.props.bulkReportRes.requestStatus != RequestStatus.SUCCESS}
                               onClick={() => {
                                   this.props.dispatchBulkProductsQueryClear();
                                   this.props.handleStepChange(1);
                                   this.props.dispatchDelAllProducts();
                                   this.publishCounter("startNewBulk", "click");
                               }}
                    />
                </div>
            </>
        );
    }
}

export default withTranslation()(connector(DownloadReportComponent));
